import {twMerge} from '@sdox/utils'
import {IconExpand} from '@sdox/icons'

import {Button} from '../Button/Button'

import type {ClassNameValue} from 'tailwind-merge'

export interface ExpandIndicatorProps {
  className?: ClassNameValue
}

export const ExpandIndicator = ({className}: ExpandIndicatorProps) => (
  <div
    className={twMerge(
      'absolute z-20',
      'bottom-spacing-12 right-spacing-12 @block-large:bottom-spacing-20 @block-large:right-spacing-20',
      className,
    )}
  >
    <Button
      size={'small'}
      variant={'overlay'}
      leading={<IconExpand />}
      tabIndex={-1}
    />
  </div>
)
